<template>
  <tr>
    <td class='td left'>
      <policy-type-badge :policyType="policy.productType" />
    </td>
    <td class='td'>
      <p class='value'>{{ policy.product.description }}</p>
    </td>
    <td class='td'>{{ policy.policyNumber}}</td>
    <td class='td right'>{{ formatDate(participation.fromDate) }} tot {{ participation.untilDate ? formatDate(participation.untilDate) : 'onbepaald' }}</td>
  </tr>
</template>

<script>
import Helpers from '@/shared/helpers/functions';

import PolicyTypeBadge from '@/views/components/policies/PolicyTypeBadge.vue';
export default {
  name: 'NewEmployeePolicyParticipation',

  props: {
    participation: null
  },

  components: {
    PolicyTypeBadge
  },

  computed: {
    policy () {
      return this.$store.getters.policies.find(
        p => p.policyNumber === this.participation.policyNumber);
    }
  },

  methods: {
    formatDate: (date) => Helpers.Dates.formatDate(date)
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';

tr {
  border-bottom: 1px solid $gray-lighten-2;

  &:first-child {
    border-top: 1px solid $gray-lighten-2;
  }
}

.td {

  padding: 7px;
  width: auto;
  &.primary {
    color: $primary;
  }

  &.left {
    padding-left: 0;
  }

  &.right {
    padding-right: 0;
  }
}
</style>
